import { Pagination } from 'interfaces/common';
import {
  BookingConfigActionTypes, GET_BOOKING_CONFIG, GET_BOOKING_CONFIG_DETAIL,
} from './actionType';

interface BookingConfigState {
  data: any;
  details: any;
  pagination: Pagination;
}

const initState: BookingConfigState = {
  data: [],
  details: {},
  pagination: {
    count: 0,
    limit: 10,
    offset: 0,
    order: 'id',
    page: 1,
    total_page: 1,
    keyword: '',
    sort: 'desc',
    category: '',
    is_publish: 'true',
  }
};

const BookingConfigReducer = (state = initState, action: BookingConfigActionTypes) => {
  switch (action.type) {
		case GET_BOOKING_CONFIG:
      return {
        ...state,
        data: action.data,
        pagination: action.pagination
      };
		case GET_BOOKING_CONFIG_DETAIL:
      return {
        ...state,
        details: action.details
      };
    default:
      return state;
  }
};

export default BookingConfigReducer;